<template>
<div class="app">
    <div class="clearfix">
      <div class="confirmed typeDiv">Confirmed</div>
      <div class="rejected typeDiv">Rejected</div>
      <div class="unhanded typeDiv">Unhanded</div>
    </div>
    <FullCalendar id="calendar" ref="fullCalendar"
      :options="calendarOptions"
    ></FullCalendar>
    <a-descriptions  class="summary">
      <a-descriptions-item v-for="(value,name) in summaryByProject" :key="name" :label="name">
        <span style="color: red; font-weight:bold;">{{value}}</span>
      </a-descriptions-item>
    </a-descriptions>
    <a-modal
        title="工时填报"
        
        okText="提交"
        cancelText="取消"
        :visible="openWorking"
        :confirm-loading="confirmLoading"
        @ok="operatingSubmitWorking"
        @cancel="closeWorking"
    >
        <div class="warning" v-if="formWorking.State == -1 ">拒绝原因:  {{formWorking.approvalContent}}</div>
        <a-form :model="formWorking" layout="vertical">
            <a-form-model-item label="姓名:">
                <a-select v-model="formWorking.UserCode" show-search option-filter-prop="children"  placeholder="请选择研发人员">
                    <a-select-option v-for="d in users" :key="d.value">
                        {{ d.value + '[' + d.text + ']' }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="所属项目">
                <a-select v-model="formWorking.ProjectCode" show-search option-filter-prop="children"  placeholder="请选择所属项目">
                    <a-select-option v-for="d in projects" :key="d.value">
                        {{ d.netWork + '[' + d.value + ']' + '[' + d.text + ']' }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="开始时间">
                <a-date-picker v-model="formWorking.StartTime" />
            </a-form-model-item>
            <a-form-model-item label="时间段">
                <a-row>
                    <a-col :span="11">
                        <a-select v-model="formWorking.timeFrom" placeholder="请选择时间">
                            <a-select-option v-for="d in timeFromOptions" 
                            :key="d.key" :value="d.value">
                            {{d.label}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="2" style="text-align: center">~</a-col>
                    <a-col :span="11">
                        <a-select v-model="formWorking.timeTo" placeholder="请选择时间">
                            <a-select-option v-for="d in timeToOptions" 
                            :key="d.key" :value="d.value">
                            {{d.label}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </a-form-model-item>
            <a-form-model-item label="工时(小时数)">
                <a-input-number v-model="formWorking.Duration" :disabled="true" />
            </a-form-model-item>
            <a-form-model-item label="Activity">
                <a-input v-model="formWorking.activity" :disabled="true" />
            </a-form-model-item>
            <a-form-model-item label="工作内容">
                <a-input v-model="formWorking.WMContent" type="textarea" />
            </a-form-model-item>
        </a-form>
    </a-modal>
</div>
</template>

<script>

import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import {formatDate} from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGrid from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
// import resourceTimelinePlugin from '@fullcalendar/resource-timeline'

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarOptions:{
        plugins: [ dayGridPlugin, interactionPlugin,timeGrid ],
        themeSystem: 'standard',
        // 试用key
        // schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        initialView: 'timeGridWeek',
        customButtons: {
          myCustomButton: {
            text: 'Change To Day Grid',
            click: () =>{
              window.location.href='#/project'
            }
          }
        },
        headerToolbar: {
            // 左边
            start: 'prev,next today',
            // 中间
            center: 'title',
            // 右边
            end: 'myCustomButton' //dayGridMonth timeGridWeek
        },
        
        expandRows: true,
        stickyHeaderDates: true,
        // dayGridMonth视图下有效，固定6周，还是不固定
        fixedWeekCount: false,
        // dayGridMonth视图下有效，仅显示本月日期
        showNonCurrentDates: false,
        // timeGrid视图下有效，是否显示全天事件
        allDaySlot: false,
        slotMinTime: '08:00',
        slotMaxTime: '20:00',
        slotDuration: '00:30:00', // 时间间隔，默认就是30分钟
        slotLabelInterval: '01:00', // 时间label的显示间隔
        scrollTime: "08:00:00",
        slotLabelFormat: {
          hour12: false,
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: 'short'
        },
        // 标识出当前时间
        nowIndicator: true, 
        businessHours: {
          // days of week. an array of zero-based day of week integers (0=Sunday)
          daysOfWeek: [ 1, 2, 3, 4, 5 ], // Monday - Thursday

          startTime: '08:00', // a start time (10am in this example)
          endTime: '20:00', // an end time (6pm in this example)
        },
        allDaySlot: false,
        nowIndicator: true,
        selectable: true,
        events: (info, successCallback, failureCallback) =>{
          let start = this.$moment(info.start.valueOf()).format("YYYY-MM-DD")
          let end = this.$moment(info.end.valueOf()).format("YYYY-MM-DD")
          //获取工时信息
          this.$axios.get('/api/Working/GetWorkingMessage?start=' + start + '&end=' + end +'').then(d => {
            let events = []
            let summary = {}
            for(let i in d.data){
              for(let j in d.data[i].children){
                let classNames = ''
                if(d.data[i].children[j].state == 0){
                  classNames = 'unhanded'
                } else if(d.data[i].children[j].state == 1){
                  classNames = 'confirmed'
                } else {
                  classNames = 'rejected'
                }
                events.push({
                  id: d.data[i].children[j].id,
                  // title: d.data[i].text + d.data[i].children[j].name ,
                  title: d.data[i].text,
                  start: d.data[i].children[j].StartTime,
                  end: d.data[i].children[j].EndTime,
                  editable: d.data[i].children[j].state != 1, 
                  classNames:classNames,
                  data: d.data[i].children[j]
                })
                console.log(d.data[i].children[j].Duration)
                console.log(summary[d.data[i].text])
                console.log("============")
                if(summary[d.data[i].text]){
                  summary[d.data[i].text] += d.data[i].children[j].Duration
                } else {
                  summary[d.data[i].text] = d.data[i].children[j].Duration
                }
                
                // tmpDuration += d.data[i].children[j].Duration
              }
            }
            this.summaryByProject = summary
            successCallback(events)
          });
        },
        eventContent: (info) => {
          return { html: '<div title="'+ info.event.extendedProps.data.name + '"><div>' + info.event.title + '</div><div>' + info.event.extendedProps.data.name + '</div></div>' }
        },
        editable: true,
        // 添加工时
        select: info => this.select(info),
        // 拖动修改工时
        eventResize: info => this.eventResizeOrDrop(info),
        // 拖动修改工时
        eventDrop: info => this.eventResizeOrDrop(info),
        // 点击修改工时
        eventClick: info => this.eventClick(info),
      },
      projects: [],
      activitys: [],
      users: [],
      // 工时填报form
      // 控制工时填报对话框的显示
      openWorking: false,
      // true - 数据提交中
      confirmLoading: false,
      // 工时填报表单数据
      formWorking: {
        State: 0,
        approvalContent: '',
        UserCode: '',
        UserName: '',
        ProjectCode: '',
        StartTime: '',
        timeFrom: '',
        timeTo: '',
        Duration: 0,
        WMContent: '',
        activity: ''
      },
      timeFrom: 80,
      timeTo: 200,
      UserInfo: {},
      summaryByProject: []
    }
  },
  created() {
    //请求用户信息
    this.$axios.get('/api/Working/GetUserInfo').then(d => {
        this.UserInfo = d.data;
        this.formWorking.UserCode = this.UserInfo.UserCode;
        this.formWorking.UserName = this.UserInfo.UserName;
        this.formWorking.activity = this.UserInfo.Activity;
    });
    //请求全部项目
    this.$axios.get('/api/Working/GetAllProject').then(d => {
        this.projects = d.data;
    });
    //请求全部Activity
    this.$axios.get('/api/Working/GetActivitys').then(d => {
        this.activitys = d.data;
    });
    //请求全部研发
    this.$axios.get('/api/Working/GetAllUser').then(d => {
        this.users = d.data;
    });
  },
  watch: {
      // 根据时间范围计算工时数
      'formWorking.timeFrom'(){
          if(this.formWorking.timeFrom && this.formWorking.timeTo){
              this.formWorking.Duration = (this.formWorking.timeTo - this.formWorking.timeFrom) / 10
          } else {
              this.formWorking.Duration = 0
          }
      },
      'formWorking.timeTo'(){
          if(this.formWorking.timeFrom && this.formWorking.timeTo){
              this.formWorking.Duration = (this.formWorking.timeTo - this.formWorking.timeFrom) / 10
          } else {
              this.formWorking.Duration = 0
          }
      }
  },
  computed: {
      timeFromOptions() {
          return this.getTimeOptions(this.timeFrom,this.timeTo)
      },
      timeToOptions() {
          let timeFrom = this.timeFrom
          if(this.formWorking.timeFrom){
              timeFrom = this.formWorking.timeFrom + 5
          }
          return this.getTimeOptions(timeFrom, this.timeTo)
      }
  },
  methods: {
    getTimeOptions(timeFrom,timeTo){
        let options = []
        for(let time = timeFrom; time <= timeTo; time+=5){
            if(time % 10 == 0){
                options.push({
                    key: 'b' + time,
                    value: time,
                    label: time / 10 + ':00'
                })
            } else {
                options.push({
                    key: 'b' + time,
                    value: time,
                    label: Math.floor(time / 10) + ':30'
                })
            }
        }
        return options
    },
    
    getCurrentView(){
      return this.$refs.fullCalendar.getApi().view.type;
    },
    select(info){
      // 仅在timeGridWeek视图下有效
      if(this.getCurrentView() != 'timeGridWeek'){
        return
      }
      // 初始化表单数据
      this.formWorking.WMContent = ''; 
      this.formWorking.ID = undefined;
      this.formWorking.WMDateTime = undefined; 
      this.formWorking.State = 0;
      this.formWorking.Code = 0;
      this.formWorking.Duration = 0;
      this.formWorking.approvalContent = '';
      let startTime = this.$moment(info.startStr)
      let endTime = this.$moment(info.endStr)
      this.formWorking.StartTime = startTime.format("YYYY-MM-DD")
      if(startTime.minute() == 0){
          this.formWorking.timeFrom = startTime.hour() * 10
      } else {
          this.formWorking.timeFrom = startTime.hour() * 10 + 5
      }
      if(endTime.minute() == 0){
          this.formWorking.timeTo = endTime.hour() * 10
      } else {
          this.formWorking.timeTo = endTime.hour() * 10 + 5
      }
      this.formWorking.Duration = (this.formWorking.timeTo - this.formWorking.timeFrom) / 10
      // 弹出工时填报对话框
      this.openWorking = true
      // // 添加工时
      // console.log(info)
      // alert('添加工时 ' + info.startStr + ' to ' + info.endStr);
      // this.$refs.fullCalendar.getApi().addEvent({
      //   title: 'dynamic event',
      //   start: info.start,
      //   end: info.end,
      //   editable: true,
      //   classNames:['unhanded'],
      //   data: {
      //     id: 1,
      //     code: 'code1'
      //   }
      // })
    },
    eventClick(info){
      // 修改工时信息
      // 仅在timeGridWeek视图下有效
      if(this.getCurrentView() != 'timeGridWeek'){
        return
      }
      // 初始化表单数据
      this.$axios.get('/api/Working/GetWorkingData?ID=' + info.event.extendedProps.data.id ).then(d => {
          this.formWorking.UserName = d.data.UserName;
          this.formWorking.UserCode = d.data.UserCode;
          this.formWorking.ProjectCode = d.data.ProjectCode;
          this.formWorking.WMContent = d.data.WMContent; 
          this.formWorking.ID = d.data.ID;
          this.formWorking.WMDateTime = d.data.WMDateTime; 
          this.formWorking.State = d.data.State;
          this.formWorking.Code = d.data.Code;
          this.formWorking.Duration = d.data.Duration;
          this.formWorking.approvalContent = d.data.approvalContent;
          this.formWorking.activity = d.data.activity;
          let startTime = this.$moment(d.data.StartTime)
          let endTime = this.$moment(d.data.EndTime)
          this.formWorking.StartTime = startTime.format("YYYY-MM-DD")
          if(startTime.minute() == 0){
              this.formWorking.timeFrom = startTime.hour() * 10
          } else {
              this.formWorking.timeFrom = startTime.hour() * 10 + 5
          }

          if(endTime.minute() == 0){
              this.formWorking.timeTo = endTime.hour() * 10
          } else {
              this.formWorking.timeTo = endTime.hour() * 10 + 5
          }
          
          // 弹出工时填报对话框
          this.openWorking = true
      });
    },
    eventResizeOrDrop(info){
      console.log(info)
      // 仅在timeGridWeek视图下有效
      if(this.getCurrentView() != 'timeGridWeek'){
        info.revert();
        return
      }
      // 修改工时截至时间
      this.$axios.get('/api/Working/GetWorkingData?ID=' + info.event.extendedProps.data.id ).then(d => {
        let data = d.data;
        let start = this.$moment(info.event.start)
        let end = this.$moment(info.event.end)
        data.StartTime = start.format("YYYY-MM-DD HH:mm:ss")
        data.EndTime = end.format("YYYY-MM-DD HH:mm:ss")
        data.Duration = end.diff(start, 'minute') / 60
        this.$axios.post('/api/Working/operatingWorking', data).then(res => {
            if(res.data.result){
              this.$message.success(res.data.msg)
              // 刷新Event显示
              this.$refs.fullCalendar.getApi().refetchEvents();
            } else {
              info.revert();  
              this.$message.error(res.data.msg)
            }
        }).catch(error=>{
          info.revert();  
          this.$message.error(error)
        });
      }).catch(error=>{
        info.revert();  
        this.$message.error(error)
      });
    },
    closeWorking(){
      this.openWorking = false
    },
    //添加——修改 工时
    operatingSubmitWorking() {
        //数据验证
        if(this.formWorking.State == 1){
            this.$message.error('工时已确认，不能修改');
            return false;
        }
        if (!this.formWorking.UserName) {
            this.$message.error('姓名,不可以为空');
            return false;
        }
        if (!this.formWorking.StartTime) {
              this.$message.error('开始时间,不可以为空');
            return false;
        }
        // if (this.isNull(this.formWorking.EndTime)) {
        //      this.$message.error('结束时间,不可以为空');
        //     return false;
        // }
        // if (!this.formWorking.WMContent) {
        //     this.$message.error('工作内容,不可以为空');
        //     return false;
        // }
        if (!this.formWorking.ProjectCode) {
              this.$message.error('请选择项目');
            return false;
        }
        if(this.formWorking.Duration <= 0){
            this.$message.error('工时错误')
            return false;
        }
        if (!this.formWorking.activity) {
              this.$message.error('请选择Activity');
            return false;
        }

        //请求后台 —— 操作工时信息
        var data = JSON.parse(JSON.stringify(this.formWorking))
        data.State = 0
        data.approvalContent = ""
        // 计算起始时间和结束时间
        let date = this.$moment(this.formWorking.StartTime).format("YYYY-MM-DD")
        let timeFrom = ""
        if(this.formWorking.timeFrom % 10 == 0){
            timeFrom = this.formWorking.timeFrom / 10 + ":00:00"
        } else {
            timeFrom = Math.floor(this.formWorking.timeFrom / 10) + ":30:00"
        }
        data.StartTime = date + " " + timeFrom 
        
        let timeTo = ""
        if(this.formWorking.timeTo % 10 == 0){
            timeTo = this.formWorking.timeTo / 10 + ":00:00"
        } else {
            timeTo = Math.floor(this.formWorking.timeTo / 10) + ":30:00"
        }
        data.EndTime = date + " " + timeTo 

        this.$axios.post('/api/Working/operatingWorking', data).then(res => {
            if(res.data.result){
              this.$message.success(res.data.msg)
              this.openWorking = false
              // 刷新Event显示
              this.$refs.fullCalendar.getApi().refetchEvents();
            } else {
              this.$message.error(res.data.msg)
            }
        });
    },
  }
}
</script>

<style scoped>
.app {
  margin: 0;
  padding: 10px;
  background-color: white;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
#calendar{
  max-width: 1100px;
  margin: 0 auto;
  max-height: 80vh;
}
.summary {
  max-width: 1100px;
  margin: 0 auto;
}
.typeDiv {
  float: right;
  /* display: inline-block; */
  padding: 5px;
  margin:5px;
  border-radius: 5px;
  color: #fff;
}
</style>
<style  lang="scss">
.confirmed {
  background-color: green;
  cursor: default;
}
.rejected {
  background-color: red
}
.unhanded {
  background-color: gray
}
.fc .fc-button-primary {
    color: #fff !important;
    background-color: #1890ff !important;
    border-color: #1890ff !important;
}
.fc .fc-button-primary:hover {
    color: #fff !important;
    background-color: #0b5ed7 !important;
    border-color: #0a58ca !important;
}
.fc .fc-button-active {
    background-color: #0b5ed7 !important;
}
.fc .fc-myCustomButton-button:active,.fc .fc-myCustomButton-button:focus,.fc .fc-myCustomButton-button:hover {
    border-color: transparent !important;
}
.fc .fc-myCustomButton-button:focus,.fc .fc-myCustomButton-button:hover {
    color: #40a9ff !important;
    background-color: transparent !important;
    // border-color: #40a9ff !important;
}
.fc .fc-myCustomButton-button {
    color: #1890ff !important;
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
</style>